// login url
const RESET_PASSWORD_CONFIRM_URL = process.env.VUE_APP_RESET_PASSWORD_CONFIRM;

export default {
  name: "PasswordResetConfirm",
  data() {
    return ({
      password: "",
      password_input_type: 'password',
      confirmPassword: "",
      error_message: "",
      success_message: "",
      is_loading: false,
      snackbar_timeout_id: null,
    });
  },
  beforeUnmount() {
    this.clear_snackbar_timer();
  },
  methods: {
    toggle_change_password_type() {
      this.password_input_type = this.password_input_type === 'password' ? 'text' : 'password';
    },
    clear_snackbar_timer() {
      if (this.snackbar_timeout_id) {
        clearTimeout(this.snackbar_timeout_id);
        this.snackbar_timeout_id = null;
      }
    },
    start_snackbar_timer() {
      this.clear_snackbar_timer();
      this.snackbar_timeout_id = setTimeout(() => {
        this.error_message = "";
        this.success_message = "";
        this.snackbar_timeout_id = null;
      }, 5000);
    },
    clear_error_message() {
      this.clear_snackbar_timer();
      this.error_message = "";
    },
    clear_success_message() {
      this.clear_snackbar_timer();
      this.success_message = "";
    },
    set_error_message(message) {
      this.error_message = message || "An error occurred while resetting the password.";
      this.success_message = "";
      this.start_snackbar_timer();
    },
    set_success_message(message) {
      this.success_message = message || "";
      this.error_message = "";
      if (message) {
        this.start_snackbar_timer();
      }
    },
    async submitNewPassword() {
        this.error_message = "";
        this.success_message = "";

        if (this.password !== this.confirmPassword) {
        this.set_error_message("Passwords do not match.");
        return;
        }

        if (this.password.length < 8) {
        this.set_error_message("Password must be at least 8 characters.");
        return;
        }

        this.is_loading = true;
        // Make login request
        const response = await fetch(RESET_PASSWORD_CONFIRM_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            new_password: this.password,
            token: this.$route.query.token
          })
        });
        if (response.ok) {
          this.set_success_message("Password has been successfully reset.");
          // Redirect to success sent email page after
        this.$router.push('/password_reset_complete');
        } else {
          const errorData = await response.json();
          this.set_error_message(errorData.detail || "An error occurred while resetting the password.");
        }

        this.is_loading = false;
    }
    }

};
